var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 5.496L11.571 4 6.47 9.342 4.43 7.205 3 8.701l3.47 3.632z","fill":"#047bf8"}));
}

Lock.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","className":"SVG SVG--inline c-bw-9"};

module.exports = Lock;

Lock.default = Lock;
